const { GET_USERROLE, UPDATE_USERROLE } = require('../../constant');

const getUserRoleAction = () => ({
  type: GET_USERROLE,
});

const updateUserRoleAction = (data) => ({
  type: UPDATE_USERROLE,
  data,
});

export { getUserRoleAction, updateUserRoleAction };
